import moment from 'moment';
import { from } from 'rxjs';
import { settingConfigs } from '../../configurations';
import { DATE_CONSTANT, APP_LANGUAGE_SUPPORTS } from '../../constants/app';
import { ORDER_TYPE, WS_LANG_KEY  } from "@/constants/app";
export const utilsFunction = {
  currencyFormatter,
  getDateFromTimestamp,
  numberFormatter,
  formatNumber,
  formatPercent,
  modifyDateFromNow,
  switchToolTipsLanguage,
  instrumentIDZeroPadding,
  isNull,
  dateStringFormat,
  instrumentIDFunction,
  dateStringFormatTwo,
  debounce,
  throttle,
  isOrderNeedEnterPrice,
  getAllUrlParams,
  joinUrlParams,
  datatableCurrencyFormatter,
  datatableFormatPercent,
  openZoomImg,
  numericalTransformation,
  sharesFormation,
}
function openZoomImg(imgsrc,isMobile) {
  let imgDiv =  document.createElement('div')
  imgDiv.id = 'img-div'
  imgDiv.style.position='fixed'
  imgDiv.style.top='0'
  imgDiv.style.left='0'
  imgDiv.style.width='100%'
  imgDiv.style.height='100%'
  imgDiv.style.zIndex='41'
  imgDiv.style.backgroundColor='rgba(0,0,0,.8)'
  document.body.appendChild(imgDiv);
  let imgZoom = document.createElement('img')
  imgZoom.id='img-zoom'
  imgZoom.style.position = 'relative'
  imgZoom.style.top = '50%'
  imgZoom.style.left = '50%'
  imgZoom.style.transform = 'translate(-50%,-50%)'
  imgZoom.src = imgsrc
  imgDiv.appendChild(imgZoom)
  if(isMobile){
    let imgHeight = document.getElementById('img-zoom').offsetWidth
    let imgWidth = document.getElementById('img-zoom').offsetHeight
    if(imgHeight < imgWidth){
      imgZoom.style.width = 'unset'
      imgZoom.style.height = '100%'
    }else if(imgWidth < imgHeight){
      imgZoom.style.width = '100%'
      imgZoom.style.height = 'unset'
    }
    imgZoom.style.objectFit = 'cover'
  }else {
    imgZoom.style.height = '70%'
  }
  imgDiv.onclick = () =>{
      document.body.removeChild(imgDiv)
  }
}


function currencyFormatter(original, decimal = 3, multiple = 1) {
  original = parseFloat(original) * multiple;
  if (!original || isNaN(original)
    || (original == '')) {
      return '-';
  }
  original = original.toFixed(decimal);
  var m = /(\d+)(?:(\.\d+)|)/.exec(original + ''), x = m[1].length > 3 ? m[1].length % 3
    : 0;
  var n = parseFloat(m[1]).toFixed(0);
  var v = (original < 0 ? '-' : '')
    + (x ? n.substr(0, x) + ',' : '')
    + n.substr(x).replace(/(\d{3})(?=\d)/g, '$1' + ',');
  v += m[2] == undefined ? Number(0).toFixed(decimal).substr(1) : m[2]
  return v;
}

function getDateFromTimestamp(timestamp) {
  const result = {
    date: '',
    fromNow: ''
  }
  let now = moment().format('DD-MM-YYYY')
  // let date = moment(parseInt(timestamp)).format('DD-MM-YYYY HH:mm:ss');
  let date = moment(parseInt(timestamp)).format('DD-MM-YYYY');
  result.date = date;
  if (now === moment(parseInt(timestamp)).format('DD-MM-YYYY')) {
    let fromNow = moment(parseInt(timestamp)).fromNow();
    fromNow = fromNow.charAt(0).toUpperCase() + fromNow.slice(1);
    result.fromNow = fromNow;
  }
  return result;
}

function numberFormatter(original = 0, separator = ',') {
  original = parseInt(original);
  if (isNaN(original)) {
    return 0;
  }
  var m = /(\d+)(?:(\.\d+)|)/.exec(original + ''), x = m[1].length > 3 ? m[1].length % 3
    : 0;
  var n = parseFloat(m[1]).toFixed(0);
  var v = (original < 0 ? '-' : '')
    + (x ? n.substr(0, x) + separator : '')
    + n.substr(x).replace(/(\d{3})(?=\d)/g, '$1' + separator);

  return v;
}

function formatNumber(amount, decimalCount = 3, decimal = ".", thousands = ",") {
  amount = parseFloat(amount);
  if (!amount || isNaN(amount) || (amount == '')) {
    amount = 0;
  }

  if (amount === 0) {
    if(decimalCount === 2 ){
      return amount + '.00';
    }else{
      return amount;
    }
  }
  //  else if (amount % 1 === 0 && decimalCount !== 2) {
  //   decimalCount = 0;
  // }

  decimalCount = Math.abs(decimalCount);
  decimalCount = isNaN(decimalCount) ? 3 : decimalCount;

  const negativeSign = amount < 0 ? "-" : "";

  let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
  let j = (i.length > 3) ? i.length % 3 : 0;

  return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
};

function formatPercent(value) {
  if (!value) {
    if (value == 0) {
      return '0.00%';
    } else {
      return '';
    }
  } else {
    return Number(value).toFixed(2) + '%';
  }
}

function modifyDateFromNow(operator, quantity, unit) {
  switch (operator) {
    case DATE_CONSTANT.ADD: return moment().add(quantity, unit).format(settingConfigs.SHORT_DATE);
    case DATE_CONSTANT.SUBTRACT: return moment().subtract(quantity, unit).format(settingConfigs.SHORT_DATE);
    default: return '';
  }
}

function switchToolTipsLanguage(language, en, cn, tc) {
  switch (language.lang) {
    case APP_LANGUAGE_SUPPORTS[0].id: {
      return tc ? tc : cn ? cn : en
    }
    case APP_LANGUAGE_SUPPORTS[1].id: {
      return cn ? cn : en
    }
    default: {
      return en
    }
  }
}

function instrumentIDZeroPadding(number) {
  if (number !== null && number !== undefined && number !== '' && number !== 'null') {
    if (typeof number !== 'number'){
      //let sun = number.length
      return '00000'.substring(number.length)+number
    }else{
      //number = Number(number)
      return (Array(5).join(0) + number).slice(-5)
    }
   
  }
}

function isNull(number){
  if (number !== null && number !== undefined && number !== '' && number !== 'null') {
    return true
  }else{
    return false
  }
}

function dateStringFormat(value) {
  var date = new Date(value)
  var year = date.getFullYear()
  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
}

function dateStringFormatTwo(value) {
  var date = new Date(value)
  var year = date.getFullYear()
  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  return year + '-' + month + '-' + day
}

function instrumentIDFunction(symbol,marketID){
  var len = symbol.length;
  var lvMaxSymbol = 9999;
  if(marketID == "MAMK"){
    lvMaxSymbol = 99999;
  }
  if(len > 0 && len <=lvMaxSymbol){
    if(marketID == "MAMK" || marketID == "SZMK"){
      symbol = "00000" + symbol;
      symbol = symbol.substr(len-1,6);
    }else{
      symbol = "0000" + symbol;
      symbol = symbol.substr(len-1,5);
    }
    return symbol
  };
}

function debounce(fn, delay = 500, immediate) {
  let timer = null,
    immediateTimer = null

  return function() {
    let args = arguments,
      context = this

    if (immediate && !immediateTimer) {
      fn.apply(context, args)
      immediateTimer = setTimeout(() => {
        immediateTimer = null
      }, delay)
    }
    if (immediateTimer) clearTimeout(immediateTimer)
    if (timer) clearTimeout(timer)

    timer = setTimeout(() => {
      fn.apply(context, args)
      timer = null
      immediateTimer = null
    }, delay)
  }
}

function throttle(fn, delay = 500, immediate = false) {
  let timer = null,
    immediateTimer = null,
    immediateRunning = !immediate

  return function() {
    let context = this,
      args = arguments

    if (immediate && !immediateRunning) {
      fn.apply(context, args)
      immediateRunning = true
      immediateTimer = setTimeout(() => {
        immediateRunning = false
      }, delay)
      return
    }

    if (!timer) {
      if (immediateTimer) {
        clearTimeout(immediateTimer)
        immediateTimer = null
      }

      timer = setTimeout(() => {
        fn.apply(context, args)
        timer = null
        immediateTimer = setTimeout(() => {
          immediateRunning = false
        }, delay)
      }, delay)
    }
  }
}

function isOrderNeedEnterPrice(orderType){
  if(orderType === ORDER_TYPE.AT_AUCTION.value || orderType === ORDER_TYPE.MARKET_ORDER.value){
      return false;
  }
  return true;
}

function getAllUrlParams(url) {
  var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
  var obj = {};
  if (!queryString) {
      return obj;
  }
  queryString = queryString.split('#')[0];
  var arr = queryString.split('&');
  for (var i = 0; i < arr.length; i++) {
      var a = arr[i].split('=');
      var paramName = a[0];
      var paramValue = typeof(a[1]) === 'undefined' ? true : a[1];
      if (paramName.match(/\[(\d+)?\]$/)) {
          var key = paramName.replace(/\[(\d+)?\]/, '');
          if (!obj[key]) obj[key] = [];
          if (paramName.match(/\[\d+\]$/)) {
              var index = /\[(\d+)\]/.exec(paramName)[1];
              obj[key][index] = paramValue;
          } else {
              obj[key].push(paramValue);
          }
      } else {
          if (!obj[paramName]) {
              obj[paramName] = paramValue;
          } else if (obj[paramName] && typeof obj[paramName] === 'string') {
              obj[paramName] = [obj[paramName]];
              obj[paramName].push(paramValue);
          } else {
              obj[paramName].push(paramValue);
          }
      }
  }
  return obj;
}

function joinUrlParams(url, data, replace = false) {
  const path = url.split('?')[0]
  if (!(data && Object.keys(data))) return url

  let allParams
  const params = getAllUrlParams(url)

  if (replace) allParams = Object.assign(params, data)
  else allParams = Object.assign(data, params)

  if (Object.keys(allParams)) {
    const paramsStr = Object.entries(allParams).reduce((prev, next, index) => (prev = [prev, [next[0], next[1]].join('=')].join(index ? '&' : ''), prev), '')
    return [path, paramsStr].join('?')
  }

  return url
}

function datatableCurrencyFormatter(original, decimal = 3, multiple = 1) {
  original = parseFloat(original) * multiple;
  if (!original || isNaN(original)
    || (original == '')) {
      if(original === 0){
        return 0
      }
    return '-'
  }
  original = original.toFixed(decimal);
  var m = /(\d+)(?:(\.\d+)|)/.exec(original + ''), x = m[1].length > 3 ? m[1].length % 3
    : 0;
  var n = parseFloat(m[1]).toFixed(0);
  var v = (original < 0 ? '-' : original > 0 ? '+' : '')
    + (x ? n.substr(0, x) + ',' : '')
    + n.substr(x).replace(/(\d{3})(?=\d)/g, '$1' + ',');
  v += m[2] == undefined ? Number(0).toFixed(decimal).substr(1) : m[2]
  if(v){
    return v
  }else{
    return '-'
  }
}

function datatableFormatPercent(value) {
  if (!value) {
    if (value == 0) {
      return '0.00%';
    } else {
      return '-';
    }
  } else {
    if(Number(value) > 0){
      return '+' + Number(value).toFixed(2) + "%";
    }else{
      return Number(value).toFixed(2) + "%";
    }
   
  }
}


function numericalTransformation(num,language){  
  if(num){
   const languages = utilsFunction.switchToolTipsLanguage(language,WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
   let negative = ''
   if(num<0){  
       num=toString(num)
       negative = '-'
       num = num.substr(1,(num.length + 1))
   }
   num = Number(num)
   if (languages == 'en') {     
       if (num >= 1000000000) {     
           if((num / 1000000000).toString().includes('.')){
               return negative + (num / 1000000000).toString().split('.')[0] + '.' + (num / 1000000000).toString().split('.')[1].substr(0, 3) + 'B'
           }else {
               return negative + (num / 1000000000) + 'B'
           }
       }else if (num >= 1000000) {
           if((num / 1000000).toString().includes('.')){
               return negative + (num / 1000000).toString().split('.')[0] + '.' + (num / 1000000).toString().split('.')[1].substr(0, 2) + 'M'
           }else {
               return negative + (num / 1000000) + 'M'
           }
       } else return num.toLocaleString(undefined, { 'minimumFractionDigits': 2, 'maximumFractionDigits': 2 })
   } else {
       if (num >= 100000000) {   
           if((num / 100000000).toString().includes('.')){
               return  negative + (num / 100000000).toString().split('.')[0] + '.' + (num / 100000000).toString().split('.')[1].substr(0, 2) + '亿'
           } else {
               return negative + (num / 100000000) + '亿'
           }
       } else if (num >= 10000) {
           if((num / 10000).toString().includes('.')){
               return negative + (num / 10000).toString().split('.')[0] + '.' + (num / 10000).toString().split('.')[1].substr(0, 2) + '万'
           }else {
             return negative +  (num / 10000) + '万'
           }
       } else 
       return num.toLocaleString(undefined, { 'minimumFractionDigits': 2, 'maximumFractionDigits': 2 })
   }
 }else return '0.00'
}

function sharesFormation(value) {
	if (value) {
		if (value >= 1000000000) {
			if ((value / 1000000000).toString().includes(".")) {
				return `${(value / 1000000000).toString().split(".")[0]}.${(value / 1000000000).toString().split(".")[1].substr(0, 1)}B`;
			}
			return `${(value / 1000000000).toFixed(1)}B`;
		}

		if (value >= 1000000) {
			if ((value / 1000000).toString().includes(".")) {
				return `${(value / 1000000).toString().split(".")[0]}.${(value / 1000000).toString().split(".")[1].substr(0, 1)}M`;
			}
			return `${(value / 1000000).toFixed(1)}M`;
		}

		if (value >= 1000) {
			if ((value / 1000).toString().includes(".")) {
				return `${(value / 1000).toString().split(".")[0]}.${(value / 1000).toString().split(".")[1].substr(0, 1)}K`;
			}
			return `${(value / 1000).toFixed(1)}K`;
		}
		return value.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
	}
	return "-";
}